import { render, staticRenderFns } from "./xiuduyou.vue?vue&type=template&id=e1d8c2ca&scoped=true&"
import script from "./xiuduyou.vue?vue&type=script&lang=ts&"
export * from "./xiuduyou.vue?vue&type=script&lang=ts&"
import style0 from "./xiuduyou.vue?vue&type=style&index=0&id=e1d8c2ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d8c2ca",
  null
  
)

export default component.exports